<template>
  <div class="login-main">
    <section>
      <!-- 背景颜色 -->
      <div class="color"></div>
      <div class="color"></div>
      <div class="color"></div>
      <div class="box">
        <!-- 背景圆 -->
        <div class="circle" style="--x:0"></div>
        <div class="circle" style="--x:1"></div>
        <div class="circle" style="--x:2"></div>
        <div class="circle" style="--x:3"></div>
        <div class="circle" style="--x:4"></div>
        <!-- 登录框 -->
        <div class="black-bg-box">
          <div class="login-form-box">
            <p>{{ ADMIN_TITLE() }}</p>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                class="login-from"
            >
              <el-form-item label="" prop="name">
                <el-input v-model="form.name" placeholder="请输入账号" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="" class="password" prop="passWord">
                <el-input
                    v-model="form.passWord"
                    show-password
                    placeholder="请输入密码"
                    maxlength="16"
                    @keyup.native.enter="submitForm"
                ></el-input>
              </el-form-item>
              <el-form-item style="margin-top: 15px;">
                <el-checkbox v-model="checked"><span class="cfff">记住密码？</span></el-checkbox>
              </el-form-item>
              <el-button
                  :loading="loading"
                  type="primary"
                  class="login-in"
                  @click="submitForm"
              >登录</el-button
              >
            </el-form>
          </div>
        </div>
      </div>
    </section>
    <google-verifcation
      ref="google"
      @handleVerify="saveUserInfo"
    ></google-verifcation>
  </div>
</template>
<script>
import API from "@/api";
import local from "@/utils/localStroage.js";
import GoogleVerifcation from "./components/google-verification";
import {ADMIN_TITLE} from "../../config";

export default {
  name: "login",
  data() {
    return {
      form: {
        name: "",
        passWord: ""
      },
      QRcode: "",
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        passWord: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      checked: false,
      loading: false
    };
  },
  components: {
    GoogleVerifcation
  },
  created() {
    // 从localStroage读取用户登录信息，存在则自动填充密码
    let loginInfo = local.get("loginInfo");
    if (loginInfo) {
      this.checked = true;
      this.form = loginInfo;
    }
  },
  methods: {
    ADMIN_TITLE() {
      return ADMIN_TITLE
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.flag = true;
          this.firstLogin();
        } else {
          return false;
        }
      });
    },
    // 登录保存登录状态到本地存储器
    firstLogin() {
      let params = Object.assign({}, this.form);
      API.login(params)
        .then(res => {
          if (res.code === 200) {
            let QRcode = res.data.qrCodePNG;
            this.QRcode = QRcode ? "data:image/png;base64," + QRcode : "";
            this.googleValidate();
          } else {
            this.$message.error("账号或密码错误，请重新登陆");
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    // 谷歌二次验证
    googleValidate() {
      this.$refs.google.open(Object.assign(this.form, { QRcode: this.QRcode }));

    },
    // 记住密码
    saveUserInfo(userInfo) {
      if (this.checked) {
        local.set("loginInfo", this.form);
      } else {
        local.remove("loginInfo");
      }
      // 将获取的权限首先存入localstorage
      let permeList = userInfo.authJson ? JSON.parse(userInfo.authJson) : [];
      // eslint-disable-next-line no-console
      local.set("role", permeList);
      // 保存用户信息
      local.set("userInfo", userInfo);
      // 刷新动态权限路由,权限路由从localstorage中获取
      this.$store.dispatch("refreshRouter");
      // 登录成功过后重定向到欢迎页面
      this.$router.push({
        path: "/home"
      });
    }
  }
};
</script>
<style lang='scss' scoped>

section {
  /* 相对定位 */
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  /* linear-gradient() 函数用于创建一个表示两种或多种颜色线性渐变的图片 */
  background: linear-gradient(to bottom, #f1f4f9, #dff1ff);
}

/* 背景颜色 */

section .color {
  /* 绝对定位 */
  position: absolute;
  /* 使用filter(滤镜) 属性，给图像设置高斯模糊*/
  filter: blur(200px);
}

/* :nth-child(n) 选择器匹配父元素中的第 n 个子元素 */

section .color:nth-child(1) {
  top: -350px;
  width: 600px;
  height: 600px;
  background: #ff359b;
}

section .color:nth-child(2) {
  bottom: -150px;
  left: 100px;
  width: 500px;
  height: 500px;
  background: #fffd87;
}

section .color:nth-child(3) {
  bottom: 50px;
  right: 100px;
  width: 500px;
  height: 500px;
  background: #00d2ff;
}

.box {
  position: relative;
}

/* 背景圆样式 */

.box .circle {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  /* backdrop-filter属性为一个元素后面区域添加模糊效果 */
  backdrop-filter: blur(5px);
  box-shadow: 0 25px 45px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  /* 使用filter(滤镜) 属性，改变颜色。
  hue-rotate(deg)  给图像应用色相旋转
  calc() 函数用于动态计算长度值
  var() 函数调用自定义的CSS属性值x*/
  filter: hue-rotate(calc(var(--x) * 70deg));
  /* 调用动画animate，需要10s完成动画，
  linear表示动画从头到尾的速度是相同的，
  infinite指定动画应该循环播放无限次*/
  animation: animate 10s linear infinite;
  /* 动态计算动画延迟几秒播放 */
  animation-delay: calc(var(--x) * -1s);
}

/* 背景圆动画 */

@keyframes animate {
  0%, 100% {
    transform: translateY(-50px);
  }
  50% {
    transform: translateY(50px);
  }
}

.box .circle:nth-child(1) {
  top: -50px;
  right: -60px;
  width: 100px;
  height: 100px;
}

.box .circle:nth-child(2) {
  top: 150px;
  left: -100px;
  width: 120px;
  height: 120px;
  z-index: 2;
}

.box .circle:nth-child(3) {
  bottom: 50px;
  right: -60px;
  width: 80px;
  height: 80px;
  z-index: 2;
}

.box .circle:nth-child(4) {
  bottom: -80px;
  left: 100px;
  width: 60px;
  height: 60px;
}

.box .circle:nth-child(5) {
  top: -80px;
  left: 140px;
  width: 60px;
  height: 60px;
}

.login-main {
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  overflow: hidden;
  position: relative;

  .black-bg-box {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 2;
  }
  .title {
    color: white;
    font-size: 52px;
    font-weight: bold;
    text-align: center;
    margin-top: 150px;
    letter-spacing: 5px;
  }


  .login-form-box {
    height: 300px;
    width:300px;
    background: rgba(255, 255, 255, 0.1);
    border:1px solid rgba(17, 17, 17, 0.1);
    margin: 80px auto;
    border-radius: 12px;
    padding:30px;
    box-sizing: content-box;
    color:#fff;
  }

  :deep(.el-input__inner){
    background-color: rgba(0, 0, 0, 0.3);
    color:#f6f6f6;
    border:1px solid rgba(34, 34, 34, 0.2) !important;
  }

  p {
    text-align: center;
    line-height: 40px;
    font-size:24px;
    font-weight: bold;
  }
  .login-from {
    // text-align: center;
    margin-top: 20px;
    .el-checkbox {
      font-weight: normal;
    }
    .login-in {
      width: 100%;
      background: rgba(0, 0, 0, 0.28);
      border:1px solid rgba(34, 34, 34, 0.37);
    }
  }
}
</style>

